import { render, staticRenderFns } from "./loginBlock.vue?vue&type=template&id=b93d0b6e&scoped=true"
import script from "./loginBlock.vue?vue&type=script&lang=js"
export * from "./loginBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93d0b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b93d0b6e')) {
      api.createRecord('b93d0b6e', component.options)
    } else {
      api.reload('b93d0b6e', component.options)
    }
    module.hot.accept("./loginBlock.vue?vue&type=template&id=b93d0b6e&scoped=true", function () {
      api.rerender('b93d0b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/loginBlock.vue"
export default component.exports